import styled from "styled-components";

const MOBILE = "@media (max-width: 480px)";
const ICON_SIZE = "18px";

export const TileIconWrap = styled.span`
  position: relative;
  display: inline-flex;
  width: ${ICON_SIZE};
  height: ${ICON_SIZE};
  align-items: center;
  justify-content: center;

  img {
    display: block;
    width: ${ICON_SIZE};
    height: ${ICON_SIZE};
  }

  ${MOBILE} {
    width: ${(props) => props.$mobileSize};
    height: ${(props) => props.$mobileSize};

    img {
      width: ${(props) => props.$mobileSize};
      height: ${(props) => props.$mobileSize};
    }
  }
`;

export const TileIconFallback = styled.span`
  display: inline-flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eef1f6;
  color: #9aa2b1;
`;
